import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqData = [
  {
    id: "1",
    question: "What is OwnFood?",
    answer:
      "OwnFood is a food delivery app that connects you with local home chefs and homemade food providers.",
  },
  {
    id: "2",
    question: "How do I order food on OwnFood?",
    answer:
      "To order food on OwnFood, simply download the app, create an account, and browse through the available home kitchens and homemade food options.",
  },
  {
    id: "3",
    question: "How long does it take to deliver food?",
    answer:
      "Delivery times vary depending on the home kitchen and your location. Once you place an order, you'll see an estimated delivery time.",
  },
  {
    id: "4",
    question: "How do I track my order?",
    answer:
      "After placing an order, you can track its progress in the app. You'll receive real-time updates on your order status.",
  },
  {
    id: "5",
    question: "How do I cancel my order?",
    answer:
      "To cancel an order, simply go to the 'Orders' section in the app and select the order you want to cancel. You can cancel the order before it's been picked up by the home chef.",
  },
  {
    id: "6",
    question: "How do I rate a home kitchen?",
    answer:
      "After completing an order, you'll have the option to rate and review the home kitchen. Your feedback helps others and improves the chef's profile.",
  },
  {
    id: "7",
    question: "How do I change my password?",
    answer:
      "To change your password, go to the 'Settings' section in the app, select 'Account', and then 'Change Password'. Follow the on-screen instructions to update your password.",
  },
];

export default function HomeFAQ() {
  const [activeKey, setActiveKey] = useState("0");

  return (
    <section className="py-4 py-md-5 bg-white">
      <div className="container" style={{ maxWidth: "680px" }}>
        {/* Header */}
        <div className="text-center mb-4">
          <h2 className="fw-semibold mb-1" style={{ fontSize: "1.5rem" }}>
            Got Questions?
          </h2>
          <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
            Quick answers to help you get started
          </p>
        </div>

        {/* Accordion wrapper */}
        <div
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
            {faqData.map((faq, index) => {
              const isActive = activeKey === String(index);

              return (
                <Accordion.Item
                  key={faq.id}
                  eventKey={String(index)}
                  style={{
                    border: "none",
                    backgroundColor: isActive ? "#f8fafc" : "#fff",
                    borderBottom:
                      index !== faqData.length - 1 ? "1px solid #eee" : "none",
                  }}
                >
                  {/* QUESTION */}
                  <Accordion.Header style={{ padding: 0 }}>
                    <div
                      className="w-100 d-flex justify-content-between align-items-center"
                      style={{
                        padding: "0.95rem 1rem",
                        fontSize: "0.92rem",
                        fontWeight: 500,
                        color: isActive ? "#0d6efd" : "#222",

                        // ✅ ONLY active item gets divider
                        borderBottom: isActive ? "1px solid #e5e7eb" : "none",
                      }}
                    >
                      {faq.question}

                      <motion.span
                        animate={{ rotate: isActive ? 180 : 0 }}
                        transition={{ duration: 0.2 }}
                        style={{ display: "flex" }}
                      >
                        <ChevronDown size={16} />
                      </motion.span>
                    </div>
                  </Accordion.Header>

                  {/* ANSWER */}
                  <Accordion.Body
                    as={motion.div}
                    initial={{ opacity: 0, y: -4 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.2 }}
                    style={{
                      padding: "0.85rem 1rem 0.95rem 1rem",
                      fontSize: "0.86rem",
                      color: "#555",
                      lineHeight: 1.55,
                    }}
                  >
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>

        {/* CTA */}
        <div className="text-center mt-3">
          <Link
            to="/faq"
            className="text-primary text-decoration-none"
            style={{
              fontSize: "0.85rem",
              fontWeight: 500,
            }}
          >
            View all FAQs →
          </Link>
        </div>
      </div>

      {/* kill bootstrap default styling noise */}
      <style>
        {`
          .accordion-button {
            padding: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
          }

          .accordion-button:focus {
            box-shadow: none !important;
            outline: none !important;
          }

          .accordion-button:not(.collapsed) {
            background: transparent !important;
            box-shadow: none !important;
          }

          .accordion-button::after {
            display: none !important;
          }

          .accordion-collapse {
            border: none !important;
          }

          .accordion-body {
            border: none !important;
          }
        `}
      </style>
    </section>
  );
}
